import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NzTypographyModule } from 'ng-zorro-antd/typography';

import { LocationService } from '../../services/location.service';
import { filter, takeUntil } from 'rxjs';

import { Location } from '../../models/location.model';
import { SubscribedComponent } from 'src/app/lib/subscribed.component';
import { ImageUrlPipe } from '../../pipes/image-url.pipe';
import { HeaderActionsComponent } from '../shared/header-actions/header-actions.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NzTypographyModule, ImageUrlPipe, HeaderActionsComponent],
})
export class HeaderComponent extends SubscribedComponent implements OnInit {
  location: Location;
  showHomeLink = false;

  constructor(
    private ref: ChangeDetectorRef,
    private locationService: LocationService,
    private router: Router,
  ) {
    super();
  }

  ngOnInit() {
    this.locationService.locationChanged.pipe(takeUntil(this.destroyed$)).subscribe((location) => {
      this.location = location;
      this.updateHomeLinkVisibility();
      this.ref.markForCheck();
    });

    this.location = this.locationService.getLocation();
    this.updateHomeLinkVisibility();

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroyed$),
      )
      .subscribe(() => {
        this.updateHomeLinkVisibility();
        this.ref.markForCheck();
      });
  }

  private updateHomeLinkVisibility(): void {
    if (!this.location?.uuid) {
      this.showHomeLink = false;
      return;
    }

    this.showHomeLink = !this.router.isActive(this.router.createUrlTree(['/', this.location.uuid, 'services']), {
      paths: 'exact',
      queryParams: 'ignored',
      fragment: 'ignored',
      matrixParams: 'ignored',
    });
  }

  onHeaderClick(): void {
    if (!this.showHomeLink || !this.location?.uuid) {
      return;
    }

    void this.router.navigate(['/', this.location.uuid, 'services']);
  }
}
